<template>
  <div id="verify-tree-grid" class="grid-view">
    <div class="main-content">
      <search-item
        config-module="2900"
        :reset="true"
        :custom-search-items="customSearchItems"
        :custom-sim-query-placeholder="$t('Message.PleaseEnterTheWarehouseNumber')"
        @click-more="value=>isAdvancedQuery=value"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemCallBack="toAdvancedQuery"
      >
        <div slot="operations">
          <!--查看-->
          <el-button no="look" :disabled="!selectedData" type="success" @click="toLook()">{{ $t('common.btn.look') }}</el-button>
          <!--新增-->
          <el-button no="new" type="primary" @click="onAdd()">{{ $t('common.btn.new') }}</el-button>
          <!--编辑-->
          <el-button no="Edit" :disabled="!selectedData" type="success" @click="editHandler()">{{ $t('SeaExport.Edit') }}</el-button>
          <!--删除-->
          <el-button no="Delete" :disabled="!selectedData" type="danger" @click="deleteHandler()">{{ $t('SeaExport.Delete') }}</el-button>
          <!--打印-->
          <el-button no="print" :disabled="!selectedData" type="primary" @click="onPrintHandler()">{{ $t('SeaExport.print') }}</el-button>
          <!--统计-->
          <el-button no="Statistics" type="primary" @click="statisticsPage()">{{ $t('SeaExport.Statistics') }}</el-button>
          <!--全部导出Excel-->
          <el-button no="ExportAllToExcel" type="primary" @click="exportAllToExcel()">{{ $t('SeaExport.ExportAllToExcel') }}</el-button>
          <!--尺寸录入-->
          <el-button no="dimensionsEntry" type="primary" @click="dimensionsEntryHandler()">{{ $t('CargoMsg.Cargo_DimensionsEntry') }}</el-button>
          <!--磅重处理-->
          <el-button no="weightHandling" type="primary" @click="weightHandlingHandler">{{ $t('CargoMsg.Cargo_WeightHandling') }}</el-button>
          <!--完全入库-->
          <!--          <el-button no="FullyStored" v-if="showWarehouseStatus" :disabled="!selectedData" type="primary" @click="onStored(true)">{{ $t('SeaExport.FullyStored') }}</el-button>-->
          <!--取消完全入库-->
          <!--          <el-button no="CancelFullWarehousing" v-if="showWarehouseStatus" :disabled="!selectedData" type="primary" @click="onStored(false)">{{ $t('SeaExport.CancelFullWarehousing') }}</el-button>-->
        </div>
      </search-item>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :config-module="isRe ? '9300100' : '9300000'"
          :grid-options="gridOptions"
          :side-bar="{ toolPanels: ['columns', 'filter'], visible: false }"
          :column-defs="columnDefs"
          :row-data="rowData"
          :grid-params.sync="gridParams"
          style="width: 100%;"
          @gridReady="onGridReady"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          :config-module="isRe ? '9300101' : '9300001'"
          :total="total"
          :page.sync="filterJson.pageNum"
          :limit.sync="filterJson.pageSize"
          @pagination="toQueryByPage"
        />
      </div>
      <!-- 统计    -->
      <warehouse-statistics-window
        v-if="statistics.show"
        :visible.sync="statistics.show"
        :warehouses-list="statistics.warehousesList"
      />
      <!-- 查询进仓照片 -->
      <picture-view-window :visible.sync="pictureView.visible" :job="pictureView.j" :model="pictureView.model" :title="pictureView.title" :file-name="pictureView.fileName" :type="pictureView.type" />
      <!-- 磅重处理 -->
      <weight-handling
        v-if="weightHandlingWindow.visible"
        :visible.sync="weightHandlingWindow.visible"
        @close="weightHandlingWindow.visible=false"
      />
      <dimensions-window
        v-if="dimensionsDialog.visible"
        :visible.sync="dimensionsDialog.visible"
        :uuid="dimensionsDialog.uuid"
        :open-imperial="openImperial"
        @close="dimensionsDialog.visible=false"
        @queryHandler="toQueryByPage"
      />

    </div>
  </div>
</template>

<script>
import CargoGridShowBigContent from '@/components/Cargo/grid/cargoGridShowBigContent.vue'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch.vue'
import { WarehouseIn } from '@/class/model/booking/WarehouseIn'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog.vue'
import { DocumentManage, stopBubble } from '@/utils/commonUtil'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cacheName, cache } from '@/utils/cacheManager'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import {
  advancedQueryFunc,
  removeFunc,
  exportAllToExcelFunc,
  queryJobByKey
} from '@/api/warehouseIn/warehouseIn'
import warehouseStatisticsWindow from './warehouseStatisticsWindow.vue'
import convertResToBlob from '@/utils/convertResToBlob'
import photo_camera from '@/assets/photo_camera-32.png'
import pictureViewWindow from '@/components/Cargo/Job/pictureViewWindow.vue'
import { updateFields, getJobByUuid } from '@/api/booking/job'
import StrUtils from '@/utils/StrUtils'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import * as WarehouseInState from '@/class/cargo/model/parameters/WarehouseInState'
import * as FbaJobConstants from '@/class/cargo/model/parameters/FbaJobConstants'
import WeightHandling from '@/components/Cargo/FrontEndWarehouse/components/warehouseHome/weightHandling.vue'
import DimensionsWindow from '@/components/Cargo/FrontEndWarehouse/components/warehousing/dimensionsWindow.vue'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import { syncSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { IMPERIAL_3 } from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'WarehousingTreeGrid',
  components: {
    DimensionsWindow,
    WeightHandling,
    CargoAdvanceSelect,
    CargoGridShowBigContent,
    searchItem,
    cargoTemplateSelectorDialog,
    warehouseStatisticsWindow,
    pictureViewWindow
  },
  props: {
    context: { type: Object, required: true },
    lob: { type: String, required: true }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      customSearchItems: [],
      isAdvancedQuery: false, // 是否为高级查询
      isEditing: false,
      filterJson: {
        pageNum: 1,
        pageSize: 10
      },
      filter: {
        frontEndWarehouse: true,
        pageNum: 1,
        pageSize: 10,
        branchId: 0, // 分公司ID
        conditions: [], // 查询条件
        snapshotConditions: [] // 高级查询条件（点击查询时的快照状态）
      },
      // 图片展示
      pictureView: {
        visible: false,
        title: '',
        model: {},
        fileName: '',
        j: {},
        type: 'WarehouseIn'
      },
      openImperial: false, // 英制单位
      dimensionsDialog: {
        uuid: '',
        visible: false
      },
      weightHandlingWindow: {
        visible: false
      },
      // 统计
      statistics: {
        show: false,
        warehousesList: []
      },
      total: 0,
      selectedData: null,
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onGridCellFocused(event)
        },
        onCellDoubleClicked: event => {
          this.toLook(event.data)
        },
        onRowClicked: this.onRowClicked,
        onRowSelected: this.onRowSelected,
        defaultColDef: {
          resizable: true
        },
        onSortChanged: (event) => {
          if (event && event.api && event.api) {
            this.rowData = event.api.getModel().rowsToDisplay.map(item => item.data)
          }
        },
        getRowStyle: (params) => {
          const row = params.data
          const { colorType } = this
          if (colorType && row.jobKey) {
            return JobUtils.financeColor(row)
          }
          return {}
        },
        context: {
          componentParent: this
        }
      },
      export: {},
      rowData: [],
      gridApi: null,
      documentManage: new DocumentManage(),
      templateSelectorDialog: { // 打印弹窗
        visible: false,
        ctx: new WarehouseIn(),
        category: '',
        data: {}
      },
      cbAutoRefresh: true
    }
  },
  computed: {
    isRe() {
      return this.lob === 'RE'
    },
    isAe() {
      return this.lob === 'AE'
    },
    showWarehouseStatus() { // 入库状态 控制
      return this.lob === 'AE' || this.lob === 'SE'
    },
    colorType() {
      return Number(this.$store.state.settings.colorType) === 1
    },
    columnDefs() {
      const result = [
        {
          headerName: '', width: 60, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('SeaExport.BusinessNo'), field: 'jobNo', width: 240, colId: 'jobNo' },
        { headerName: this.$t('SeaExport.WarehouseNo'), field: 'warehouseNo', width: 180, colId: 'warehouseNo' },
        { headerName: this.getMAWBLabel(), field: 'mbl', width: 180, colId: 'mbl',
          valueFormatter: (params) => {
            return ColumnUtils.mawbNoLabelFun(params.value)
          }
        },
        { headerName: this.$t('Warehouse.ReceiptNumber'), field: 'receiptNo', width: 180, colId: 'receiptNo' },
        { headerName: this.lob === 'RE' ? this.$t('Billing.Destination') : this.$t('Warehouse.PortOfDestination'), field: 'destinationPort', width: 180, colId: 'destinationPort',
          valueFormatter: (params) => {
            let portName = ''
            if (params.data.lob === 'SE' || params.data.lob === 'SI') {
              portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            } else if (params.data.lob === 'AE' || params.data.lob === 'AI') {
              portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
            } else if (params.data.lob === 'RE') {
              portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
            }
            return (!StrUtils.isEmpty(portName)) ? portName : params.value
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ActualWarehousingTime'), field: 'warehouseInDate', width: 180, colId: 'warehouseInDate',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_EstimatedWarehousingTime'), field: 'estimatedWarehousingTime', width: 180, colId: 'estimatedWarehousingTime',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          hide: !this.isAe,
          suppressColumnsToolPanel: !this.isAe
        },
        { headerName: this.$t('CargoMsg.Cargo_EstimatedDeliveryTime'), field: 'estimatedDeliveryTime', width: 180, colId: 'estimatedDeliveryTime',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          hide: !this.isAe,
          suppressColumnsToolPanel: !this.isAe
        },
        { headerName: this.$t('Warehouse.InputTime'), field: 'dateCreated', width: 180, colId: 'dateCreated',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Warehouse.DataEntryClerk'),
          field: 'createdBy',
          width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', parseInt(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('Warehouse.NumberOfCases'), field: 'quantitySum', width: 180, colId: 'quantitySum',
          valueFormatter: (params) => {
            return ColumnUtils.formatNumber(params.value, 0, true)
          }
        },
        { headerName: this.$t('Warehouse.Weight'), field: 'weightSum', width: 180, colId: 'weightSum',
          valueFormatter: (params) => {
            return ColumnUtils.formatNumber(params.value, 2, true)
          }
        },
        { headerName: this.$t('Warehouse.Volume'), field: 'cubageSum', width: 180, colId: 'cubageSum',
          valueFormatter: (params) => {
            return ColumnUtils.formatNumber(params.value, 3, true)
          }
        },
        { headerName: this.$t('Warehouse.ComputationIsAffectedByDampness'), field: 'broken', width: 180, colId: 'broken',
          valueFormatter: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          }
        },
        { headerName: this.$t('Warehouse.IntoTheWarehousePhotos'), field: 'uuid', width: 180, colId: 'picContent', noExport: true,
          cellRenderer: params => {
            const obj = this.rowData.find(x => x.uuid === params.data.uuid)
            if (obj.businessDocumentVOList.length > 0) {
              const methodPath = this.documentManage.getPath('showAttachHandler')
              return `<span><img src="${photo_camera}" height="16" width="16" style="vertical-align: sub;cursor:pointer" onclick="${methodPath}(event)"/></span>`
            }
            return ''
          }
        },
        { headerName: this.$t('Warehouse.WarehouseName'), field: 'warehouse', width: 180, colId: 'warehouse' },
        { headerName: this.$t('Warehouse.Warehouseman'), field: 'warehouseOp', width: 180, colId: 'warehouseOp',
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', parseInt(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.ConsignationCompany'),
          field: 'customer',
          colId: 'customer',
          hide: true,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_0') : ''
          },
          width: 200
        }, {
          headerName: this.$t('Warehouse.WarehouseInState'),
          colId: 'state',
          field: 'state',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_WarehouseInState$WAREHOUSE_STATE_LIST, 'code', Number(params.value), 'chineseName')
          },
          hide: !this.showWarehouseStatus,
          suppressColumnsToolPanel: !this.showWarehouseStatus
        }, {
          headerName: this.$t('Warehouse.DescriptionOfGoods'),
          colId: 'brokenDes',
          field: 'brokenDes',
          width: 150,
          hide: true,
          tooltipValueGetter: (params) => {
            return params.value
          }
        }, {
          headerName: this.$t('Warehouse.HandlingOpinions'),
          colId: 'comments',
          field: 'comments',
          width: 150,
          hide: true,
          tooltipValueGetter: (params) => {
            return params.value
          }
        }, {
          headerName: this.$t('Warehouse.Remark'),
          colId: 'remarks',
          field: 'remarks',
          width: 150,
          hide: true,
          tooltipValueGetter: (params) => {
            return params.value
          }
        }, {
          headerName: this.$t('SeaExport.Marks'),
          field: 'jobMark',
          colId: 'jobMark',
          initialWidth: 100,
          hide: true
        }
      ]
      if (this.lob === 'SE') {
        result.push({
          headerName: this.$t('SeaExport.BusinessReferenceNo'),
          field: 'customerRefNo',
          colId: 'customerRefNo',
          width: 150
        }, {
          headerName: this.$t('queryJob.businessDate'),
          field: 'businessDate',
          colId: 'businessDate',
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.Vessel'),
          field: 'vessel',
          colId: 'vessel',
          width: 150
        }, {
          headerName: this.$t('SeaExport.Voyage'),
          field: 'voyageFlight',
          colId: 'voyageFlight',
          width: 150
        }, {
          headerName: this.$t('SeaExport.SolicitationType'),
          field: 'cargoSource',
          colId: 'cargoSource',
          cellRenderer: (params) => {
            return ColumnUtils.cargoSourceLabelFunction(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.FLCLType'),
          field: 'containerLoadType',
          colId: 'containerLoadType',
          cellRenderer: (params) => {
            return ColumnUtils.containerLoadTypeLabelFunction(params.data, 'containerLoadType')
          },
          width: 150,
          filter: false,
          filterParams: {}
        }, {
          headerName: this.$t('SeaExport.CargoType'),
          field: 'cargoType',
          colId: 'cargoType',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoType, 'code', params.value, 'chineseName')
          },
          width: 150
        }, {
          headerName: this.$t('queryJob.destinationAgent'),
          field: 'destinationAgent',
          colId: 'destinationAgent',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_2') : ''
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.NominatedAgent'),
          field: 'designationAgent',
          colId: 'designationAgent',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_3') : ''
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.Sales'),
          field: 'sales',
          colId: 'sales',
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_sales')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.Operation'),
          field: 'op',
          colId: 'op',
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_op')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.Documents'),
          field: 'dc',
          colId: 'dc',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.CustomerService'),
          field: 'csr',
          colId: 'csr',
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_csr')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.OverseaCustomerService'), field: 'overseaOp', width: 180, colId: 'overseaOp',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.AirlinePerson2'),
          field: 'planner',
          colId: 'planner',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_SalesDepartment'),
          field: 'salesDept',
          colId: 'salesDept',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_OperationDepartment'),
          field: 'opDepartment',
          colId: 'opDepartment',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', params.value, 'chineseName')
          }
        })
      }
      if (this.openImperial) {
        result.push({ headerName: this.$t('Warehouse.Weight') + '(LB)', field: 'weightSumImperial', width: 180, colId: 'weightSumImperial',
          valueFormatter: (params) => {
            return ColumnUtils.formatNumber(params.value, 2, true)
          }
        },
        { headerName: this.$t('Warehouse.Volume') + 'CFT', field: 'cubAgeSumImperial', width: 180, colId: 'cubAgeSumImperial',
          valueFormatter: (params) => {
            return ColumnUtils.formatNumber(params.value, 3, true)
          }
        })
      }
      return result
    }
  },
  watch: {
    lob: {
      immediate: true,
      handler(newVal) {
        const defaultSearchFields = []
        // 实际入库日期
        let searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.UPDATE_ACTION
        searchField.itemType = 'date'
        searchField.itemCondition = []
        searchField.subType = 'range'
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_DATE_RANGE'
        searchField.itemName = 'warehouseIn.WAREHOUSE_IN_DATE'
        searchField.itemLabel = 'Warehouse.ActStorageDay'
        searchField.itemValue = []
        searchField.defaultSelected = 1
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        defaultSearchFields.push(searchField.formatObj2Json())
        // 实际出库日期
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.UPDATE_ACTION
        searchField.itemType = 'date'
        searchField.itemCondition = []
        searchField.subType = 'range'
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_DATE_RANGE'
        searchField.itemName = 'warehouseIn.WAREHOUSE_OUT_DATE'
        searchField.itemLabel = 'Warehouse.ActDeliveryDay'
        searchField.itemValue = []
        searchField.defaultSelected = 1
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        defaultSearchFields.push(searchField.formatObj2Json())
        if (newVal === 'SE') {
          defaultSearchFields.push({
            'action': 0,
            'itemType': 'select',
            'multiple': 1,
            'itemCondition': [],
            'defaultConditionVal': '',
            'fieldType': 'FIELD_MULTI_DROP_DOWN_LIST',
            'itemName': 'seaJob.CONTAINER_LOAD_TYPE',
            'itemLabel': 'SeaExport.FLCLType',
            'itemValue': [],
            'defaultSelected': 0,
            'selected': 0,
            'dropdownDataRef': 'SeaExportConstants.CONTAINER_LOAD_TYPES',
            'dataCacheKey': 'local_cache_SeaExportConstants$CONTAINER_LOAD_TYPES',
            'valueExpression': '',
            'lock': false,
            'defaultValue': []
          })
        } else if (newVal === 'AE') {
          // 预计入库日期
          searchField = new AdvancedSearchField()
          searchField.action = AdvancedSearchField.ADD_ACTION
          searchField.itemType = 'date'
          searchField.itemCondition = []
          searchField.subType = 'range'
          searchField.defaultConditionVal = ''
          searchField.fieldType = 'FIELD_DATE_RANGE'
          searchField.itemName = 'warehouseIn.ESTIMATED_WAREHOUSING_TIME'
          searchField.itemLabel = 'CargoMsg.Cargo_EstimatedWarehousingTime'
          searchField.itemValue = []
          searchField.defaultSelected = 1
          searchField.selected = 0
          searchField.dropdownDataRef = ''
          searchField.lock = false
          searchField.defaultValue = []
          defaultSearchFields.push(searchField.formatObj2Json())
          // 预计出库日期
          searchField = new AdvancedSearchField()
          searchField.action = AdvancedSearchField.ADD_ACTION
          searchField.itemType = 'date'
          searchField.itemCondition = []
          searchField.subType = 'range'
          searchField.defaultConditionVal = ''
          searchField.fieldType = 'FIELD_DATE_RANGE'
          searchField.itemName = 'warehouseIn.ESTIMATED_DELIVERY_TIME'
          searchField.itemLabel = 'CargoMsg.Cargo_EstimatedDeliveryTime'
          searchField.itemValue = []
          searchField.defaultSelected = 1
          searchField.selected = 0
          searchField.dropdownDataRef = ''
          searchField.lock = false
          searchField.defaultValue = []
          defaultSearchFields.push(searchField.formatObj2Json())
        }
        if (newVal !== 'AE' && newVal !== 'SE') {
          // 入库状态
          searchField = new AdvancedSearchField()
          searchField.action = AdvancedSearchField.REMOVE_ACTION
          searchField.itemType = 'select'
          searchField.itemCondition = []
          searchField.defaultConditionVal = ''
          searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
          searchField.itemName = 'warehouseIn.STATE'
          searchField.itemLabel = 'Warehouse.WarehouseInState'
          searchField.itemValue = []
          searchField.defaultSelected = 0
          searchField.selected = 0
          searchField.dropdownDataRef = 'WarehouseInState.WAREHOUSE_STATE_LIST'
          searchField.dataCacheKey = 'local_cache_WarehouseInState$WAREHOUSE_STATE_LIST'
          searchField.lock = false
          searchField.defaultValue = []
          defaultSearchFields.push(searchField.formatObj2Json())
        }
        this.customSearchItems = defaultSearchFields
      }
    }
  },
  async created() {
    await this.preloadBasicData()
    await cache.load(cacheName.OFFICE, cacheName.CONFIG)
    this.office = cache.office
  },
  beforeMount() {
    const context = this
    this.documentManage.set('showBusinessInfo', function() {
      context.showBusinessInfo()
    })
    this.documentManage.set('showAttachHandler', function() {
      context.showAttachHandler()
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    // 选中 勾选框或者其他列 都会触发[获取选中行]
    onGridCellFocused(event) {
      if (!event) return
      this.selectedData = null
      if (this.gridApi && event.column) {
        this.gridApi.forEachNode(node => {
          if (node && node.rowIndex === event.rowIndex && node.data) {
            const nodeWarehouse = node.data
            if (nodeWarehouse.uuid) this.selectedData = nodeWarehouse
          }
        })
      }
    },
    onGridReady(p) {
      this.gridApi = p.api
    },
    getMAWBLabel() {
      let label = ''
      switch (this.lob) {
        case 'RE':
          label = this.$t('Billing.WayBillNumber')
          break
        case 'AE':
        case 'AI':
          label = 'MAWB'
          break
        case 'SE':
        case 'SI':
          label = 'MB/L'
          break
      }
      return label
    },
    // 行首多选框勾选事件
    onRowSelected(event) {
      if (!event || !event.data) return
      this.selectedData = null
      if (event.node.isSelected()) {
        this.onRowClicked(event)
      }
    },
    // 行点击触发事件
    onRowClicked(event) {
      if (!event || !event.data) return
      this.selectedData = null
      const node = event.data
      if (node.uuid) this.selectedData = node
    },
    // 初始化配置参数
    async preloadBasicData() {
      await cache.load(cacheName.CONFIG)
      this.init()
    },
    init() {
      // 加载英制单位配置
      JobUtils.initImperialData(IMPERIAL_3.code).then(r => {
        this.openImperial = r
      })
    },
    // 查询[简单查询/高级查询]
    toQuery() {
      this.filter.pageNum = 1
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery(this.filter.snapshotConditions)
      } else {
        this.toSimpleQuery()
      }
    },
    // 分页查询
    toQueryByPage() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery(this.filter.snapshotConditions)
      } else {
        this.toSimpleQuery()
      }
    },
    // 高级查询
    toAdvancedQuery(data) {
      this.filter.warehouseNo = ''
      this.filter.conditions = []
      this.filter.lob = this.lob
      if (typeof data !== 'undefined') {
        this.filter.snapshotConditions = [... data] // 高级查询条件（点击查询时的快照状态）
        this.filter.conditions = [... data]
        this.filter.pageNum = 1
      }
      if (this.colorType) {
        this.filter.requires = ['financeColor']
      }
      this.filter.branchId = this.$store.getters.currentOfficeId
      this.filter.pageNum = this.filterJson.pageNum
      this.filter.pageSize = this.filterJson.pageSize
      this.loading = getLoading()
      advancedQueryFunc(this.filter).then(res => this.handleQueryData(res)).catch((err) => {
        this.$message.error(err)
        this.loading.close()
      })
    },
    // 简单查询
    toSimpleQuery(keyword) {
      const conditions = []
      if (typeof keyword !== 'undefined') {
        const condition = new AdvancedSearchOption(null, 'warehouseIn.WAREHOUSE_NO', keyword.trim(), OperatorConstants.OPERATOR_LIKE.code)
        conditions.push(condition.formatObj2Json())
      }
      this.toAdvancedQuery(conditions)
    },
    // 查询返回结果[公用]
    handleQueryData(res) {
      this.rowData = res.data.list
      this.filterJson.pageNum = res.data.pageNum
      this.filterJson.pageSize = res.data.pageSize
      this.total = Number(res.data.total)
      this.selectedData = null
      this.gridApi.clearFocusedCell()
      this.loading.close()
    },
    updateListData(res) {
      this.rowData = res
    },
    // 显示进仓图片
    showAttachHandler(e) {
      if (!this.selectedData) {
        this.$message.warning('请选择一条数据！')
        return
      }
      this.pictureView.title = this.$t('Message.ViewWarehouseEntryPhotos')
      this.pictureView.model = this.selectedData
      this.pictureView.fileName = this.selectedData.warehouseNo + '.zip'
      this.pictureView.type = 'WarehouseIn'
      if (this.selectedData.jobUuid) {
        getJobByUuid(this.selectedData.jobUuid).then(res => {
          this.pictureView.j = res.data
          this.pictureView.visible = true
        })
      } else {
        this.pictureView.j = {}
        this.pictureView.visible = true
      }
    },
    // 查看
    toLook(row) {
      row = this.getRowData(row)
      if (!row) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      this.$emit('look', row)
    },
    // 新增
    onAdd() {
      this.$emit('add')
    },
    getRowData(row) {
      if (!row) {
        row = this.selectedData
      }
      if (!row) {
        const rows = this.readSelectedRows()
        if (rows && rows.length > 0) {
          row = rows[0]
        }
      }
      return row
    },
    // 编辑
    editHandler(row) {
      row = this.getRowData(row)
      if (!row) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      if (row.instoreFrom) {
        this.$message.info(this.$t('Warehouse.CannotEditExternalData'))
        return
      }
      if (row.warehouseStatus === WarehouseInState.FULLY_STORED.code) {
        this.$message.warning(this.$t('SeaExport.StoredTipFour'))
        return
      }
      this.$emit('edit', row)
    },
    // 删除
    deleteHandler(row) {
      row = this.getRowData(row)
      if (!row) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      if (row.instoreFrom) {
        this.$message.info(this.$t('Message.ExternalDataCannotBeDeleted'))
        return
      }
      if (row.warehouseStatus === WarehouseInState.FULLY_STORED.code) {
        this.$message.warning(this.$t('SeaExport.StoredTipFour'))
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_SureToDelete'), this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
        cancelButtonText: this.$t('CargoMsg.Cargo_No'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.loading = getLoading()
        removeFunc({ warehouseInUuid: row.uuid }).then(resp => {
          if (!resp.data) {
            this.$message.warning(this.$t('SeaExport.StoredTipFour'))
            return
          }
          this.$message.success(this.$t('SeaExport.DeleteSucceeded'))
          syncSpecificBasicData(basicCacheKeys.basic_data_LocationConfiguration)
          syncSpecificBasicData(basicCacheKeys.basic_data_PalletConfiguration)
          this.toQueryByPage()
        }).catch(() => {
          this.loading.close()
        }).finally(() => this.loading.close())
      })
    },
    // 打印
    onPrintHandler() {
      let rows = []
      const selectedRows = this.readSelectedRows()
      if (!this.selectedData && selectedRows.length === 1) {
        rows = this.selectedData
      } else {
        rows = selectedRows
      }
      this.$emit('print', rows)
    },
    // 获取勾选行
    readSelectedRows() {
      return this.gridApi.getSelectedRows()
    },
    // 列表 业务编号旁边搜索框的打印
    showBusinessInfo(e) {
      stopBubble(e)
      if (!this.selectedData) return
      this.templateSelectorDialog.ctx = new WarehouseIn(this.selectedData)
      this.templateSelectorDialog.category = 'JOB_DETAIL_OP'
      this.templateSelectorDialog.data = { 'JOB_UUID': this.selectedData.uuid }
      this.templateSelectorDialog.visible = true
    },
    statisticsPage(e) {
      const selectedList = this.readSelectedRows()
      if (!selectedList || selectedList.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      this.statistics.show = true
      this.statistics.warehousesList = selectedList
    },
    exportAllToExcel() {
      this.export = {}
      const data = this.filter.snapshotConditions
      this.export.pageNum = 1
      this.export.pageSize = 10000
      this.export.lob = this.lob
      this.export.conditions = []
      this.export.branchId = this.$store.getters.currentOfficeId
      if (this.isAdvancedQuery) {
        if (typeof data !== 'undefined') {
          this.export.snapshotConditions = [... data] // 高级查询条件（点击查询时的快照状态）
          this.export.conditions = [... data]
        }
      } else {
        this.export.warehouseNo = ''
      }
      this.loading = getLoading()
      exportAllToExcelFunc(this.export).then(res => {
        convertResToBlob(res)
        this.$message.success(this.$t('Message.RequestSucceededExporting'))
        this.loading.close()
      }).catch((err) => {
        this.$message.error(err)
        this.loading.close()
      })
    },
    // 完全入库/取消完全入库
    onStored(isOk = false) {
      const selects = this.readSelectedRows()
      if (!selects || selects.length <= 0) {
        this.$message.warning(this.$t('Message.SelectTheData'))
        return
      }
      const warehouseStatus = isOk ? WarehouseInState.PARTIAL_WAREHOUSING.code : WarehouseInState.FULLY_STORED.code
      const jobKeys = []
      for (const cur of selects) {
        if (Number(cur.warehouseStatus) !== Number(warehouseStatus)) {
          const label = ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_WarehouseInState$WAREHOUSE_STATE, 'code', Number(warehouseStatus), 'chineseName')
          this.$message.warning(this.$t('SeaExport.StoredTipThree', [label]))
          return
        }
        if (!cur.jobUuid) continue
        jobKeys.push(cur.jobUuid)
      }
      if (jobKeys.length <= 0) {
        this.$message.warning(this.$t('SeaExport.SelectedRightData'))
        return
      }
      // 校验业务编号有多少个进仓单
      let loading = getLoading4Cxt(this)
      const self = this
      queryJobByKey({ keys: jobKeys }).then(res => {
        const obj = res.data
        const strs = []
        for (const cur of selects) {
          if (!cur.jobUuid || !cur.jobNo || !obj[cur.jobUuid]) continue
          strs.push(this.$t('SeaExport.StoredTipOne', [cur.jobNo, obj[cur.jobUuid]]))
        }
        if (strs.length > 0) {
          const msg = isOk ? this.$t('SeaExport.FullyStored') : this.$t('SeaExport.CancelFullWarehousing')
          strs.push(this.$t('SeaExport.StoredTipTwo', [msg]))
          const str = strs.join('<br>')
          this.$confirm(str, this.$t('Message.Prompt'), {
            dangerouslyUseHTMLString: true,
            confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
            cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
            showClose: false,
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
            //
            loading = getLoading4Cxt(self)
            const obj = {}
            obj.keys = jobKeys
            obj.anyInteger = isOk ? WarehouseInState.FULLY_STORED.code : WarehouseInState.PARTIAL_WAREHOUSING.code
            obj.anyStr = FbaJobConstants.WAREHOUSE_OP_STORED
            updateFields(obj).then(res => {
              if (res.data > 0) {
                this.$message.success(msg + this.$t('Message.Success'))
                this.toQuery()
              }
            }).finally(() => {
              loading.close()
            })
          }).catch(() => {
          })
        } else {
          this.$message.warning(this.$t('SeaExport.SelectedRightData'))
        }
      }).finally(() => {
        loading.close()
      })
    },
    dimensionsEntryHandler() {
      const row = this.getRowData(row)
      if (!row) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      if (row.warehouseStatus === WarehouseInState.FULLY_STORED.code) {
        this.$message.warning(this.$t('SeaExport.StoredTipFour'))
        return
      }
      this.dimensionsDialog.uuid = row.uuid
      this.dimensionsDialog.visible = true
    },
    // 磅重处理
    weightHandlingHandler() {
      this.weightHandlingWindow.visible = true
    }
  }
}
</script>

<style lang="scss">
  #app #verify-tree-grid {
    .not-click {
      pointer-events: none;
      button {
        color: #fff;
        background-color: #8cc8ff;
        border-color: #acbcca;
        cursor: not-allowed;
      }
    }
    button.not-click {
      color: #fff;
      background-color: #8cc8ff;
      border-color: #8cc8ff;
      cursor: not-allowed;
    }

  }
</style>
